import React, { createContext, useContext, useState } from 'react';

// Create the context
const AppContext = createContext();

// Create a provider component
export const AppProvider = ({ children }) => {
  const base_url = "https://api.slipstreamautomations.com";
  const [token, setToken] = useState(null);
  const [user, setUser] = useState(null);
  const [company, setCompany] = useState(null);
  const [activities, setActivities] = useState([]);
  const [history, setHistory] = useState(30);

  return (
    <AppContext.Provider value={{ 
      base_url,
      token, setToken,
      user, setUser,
      company, setCompany,
      activities, setActivities,
      history, setHistory
    }}>
      {children}
    </AppContext.Provider>
  );
};

// Create a custom hook to use the context
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
}; 